<template>
<div :style="styles">
    <div v-if="debug">
        <h2>OAUTH Response</h2>

        <v-btn color="red" v-if="hasOauthResponse" @click="tokenRequest">(2) Request PKCE Token</v-btn>

        <ul>
            <li>
                <b>currentUrl</b>:<br />
                <code>{{currentUrl}}</code>
            </li>
            <li>
                <b>hasOauthResponse</b>:<br />
                <code>{{hasOauthResponse}}</code>
            </li>
            <li>
                <b>postOptions</b>:<br />
                <code>{{postOptions}}</code>
            </li>
            <li>
                <b>credentials</b>:<br />
                <code>{{credentials}}</code>
            </li>
        </ul>
    </div>

</div>
</template>

<script>
import axios from "axios"
import oauthMixin from "./oauth-mixin"
import moment from "moment"

export default {
    name: 'OAUTHResponse',
    mixins: [oauthMixin],
    async mounted() {
        if (this.hasOauthResponse) {
            await this.tokenRequest();
        }
    },
    props: {
    },
    data() {
        return {
            responseData: null,
            error: null,
        }
    },

    watch: {
        async hasOauthResponse(newVal) {
            if (newVal) {
                await this.processOAUTHResponse();
            }
        },
        responseData(newVal) { //result of an http response.
            if (!!newVal.data) {

                var credentials = this.extendCredentials(newVal.data);
                this.internalCredentials = credentials;

                var args = Object.assign(this.storedState, newVal.data);
                this.$emit("credentials-new", args);
            }
        },
    },
    computed: {
        storedState() {
            if (!!this.querystring.state) {
                return JSON.parse(window.localStorage.getItem(this.querystring.state));
            }
        },
        postOptions() {
            return !!this.storedState ? {
                grant_type: 'authorization_code',
                client_id: this.storedState.client_id,
                redirect_uri: this.storedState.redirect_uri,
                code: this.querystring.code,
                code_verifier: this.storedState.code_verifier,
                scope: `${this.storedState.scope} offline_access`,
            } : null;
        }
    },
    methods: {
        async tokenRequest() {
            var self = this;
            try {
                // var result = await axios.post(this.storedState.token_uri, this.postOptions);
                let formData = new FormData();
                Object.keys(self.postOptions).forEach(e => {
                    formData.append(e, self.postOptions[e]);
                });
                self.responseData = await axios({
                    method: 'post',
                    url: self.storedState.token_uri,
                    data: formData,
                });

            } catch (err) {
                console.error(err);
                this.error = err;
            } finally {}
        },
        async processOAUTHResponse() {
            //Pickup the stored storedState info. (use it now or never)
            try {
                var self = this;
                // self.storedState = JSON.parse(window.localStorage.getItem(this.querystring.state));
                if (self.automatic) {
                    setTimeout(await self.tokenRequest, self.automaticDelay);
                }
            } catch (err) {
                console.error(err);
                self.error = err;
            } finally {
                // window.localStorage.removeItem(this.querystring.state);
            }
        }
    }
}
</script>
